import React from "react";
import InputSwitch from "../../../../../components/input/input-switch.jsx";

const ToggleCellRenderer = ({
                                value,
                                data,
                                rowIndex,
                                onToggleChange,
                            }) => {

    const handleToggleChange = (newValue) => {
        if (onToggleChange) {
            onToggleChange(
                data.id,
                data.pattern,
                newValue,
                data
            );
        }
    };

    return (
        <div className="flex items-center justify-center h-full">
            <InputSwitch
                id={`toggle-${data.id || rowIndex}`}
                title={!value ? "Habilitar jornada" : "Desabilitar jornada"}
                checked={!!value}
                onChange={handleToggleChange}
                className="justify-center"
            />
        </div>
    );
};

export default ToggleCellRenderer;
